module.exports = __webpack_public_path__ + "img/settings-2.c318790d.png";